/* eslint-disable @typescript-eslint/no-explicit-any */
// import { environments } from "@/lib/config";

// const apiUrl = environments?.aiChatUrl || "";

export async function getAIChatStream(
  input: string,
  isLogin: boolean,
  userId: string,
  sessionId: string,
  onChunk: (content: string, meta?: any) => void
) {
  const res = await fetch("/api/chat/stream", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      messages: [{ role: "user", content: input }],
      limit: 10,
      stream: true,
      user_type: isLogin ? "member" : "guest",
      user_id: userId.toString(),
      sessionId,
    }),
  });

  if (!res.body) throw new Error("No response body");

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.replace(/\r\n|\r/g, "\n").split(/\n{2,}/);
    buffer = parts.pop() || "";

    for (const part of parts) {
      if (!part.startsWith("data:")) continue;
      const data = part.replace("data:", "").trim();
      if (data === "[DONE]") return;

      try {
        const json = JSON.parse(data);
        onChunk(json.content ?? "", json.metadata);
      } catch (e) {
        console.error("Parse error", e, data);
      }
    }
  }
}
